import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import { useChampionTheme } from '../../components/ChampionElements';

const typeIcons = {
  pdf: 'bi-file-pdf text-danger', image: 'bi-file-image text-primary',
  document: 'bi-file-word text-info', presentation: 'bi-file-ppt text-warning',
  other: 'bi-file-earmark text-secondary',
};
const typeColors = { pdf: '#EF4444', image: '#3B82F6', document: '#06B6D4', presentation: '#F59E0B', other: '#6B7280' };

export default function MaterialList() {
  const { webinarId } = useParams();
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const t = useChampionTheme();

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const res = await api.get(`/api/member/webinars/${webinarId}/materials`);
        setMaterials(res.data);
      } catch (err) { console.error('Gagal memuat materi:', err); }
      finally { setLoading(false); }
    };
    fetchMaterials();
  }, [webinarId]);

  const handleDownload = async (material) => {
    if (!material.can_download) { alert('Materi ini tidak dapat diunduh.'); return; }
    try {
      const res = await api.get(`/api/member/materials/${material.id}/download`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a'); link.href = url;
      link.setAttribute('download', material.extension ? `${material.title}.${material.extension}` : material.title);
      document.body.appendChild(link); link.click(); link.remove();
    } catch (err) { alert('Gagal mengunduh materi.'); }
  };

  if (loading) return <div className="text-center py-5"><div className="spinner-border" style={{ color: t.gold }} role="status" /><p className="mt-3" style={{ color: t.gold }}>Memuat materi...</p></div>;

  if (materials.length === 0) return (
    <div className="text-center py-5">
      <i className="bi bi-file-earmark-text" style={{ fontSize: '3rem', color: t.textMuted }}></i>
      <p className="mt-3" style={{ color: t.textMuted }}>Materi akan segera hadir!</p>
      <p style={{ color: t.textMuted, fontSize: '0.85rem' }}>Tim pengajar sedang menyiapkan materi terbaik untukmu.</p>
    </div>
  );

  return (
    <div style={{ animation: 'slide-in-up 0.5s ease' }}>
      <div className="d-flex align-items-center gap-2 mb-4">
        <i className="bi bi-file-earmark-text" style={{ color: t.gold, fontSize: '1.5rem' }}></i>
        <h5 style={{ color: t.gold, fontWeight: 700, margin: 0 }}>Materi Pendukung</h5>
        <span style={{ fontSize: '0.7rem', fontWeight: 700, color: t.textMuted, background: t.elementBg, borderRadius: '20px', padding: '3px 10px', marginLeft: '4px' }}>{materials.length} file</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {materials.map((mat, index) => {
          const tc = typeColors[mat.file_type] || typeColors.other;
          return (
            <div key={mat.id} className="d-flex align-items-center justify-content-between animate-slide-up" style={{
              animationDelay: `${index * 0.08}s`, background: t.cardBg, border: `1px solid ${t.borderLight}`,
              borderRadius: '12px', padding: '16px', transition: 'all 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = `${t.gold}44`; e.currentTarget.style.background = `${t.gold}06`; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = t.borderLight; e.currentTarget.style.background = t.cardBg; }}
            >
              <div className="d-flex align-items-center">
                <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: `${tc}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '14px' }}>
                  <i className={`bi ${typeIcons[mat.file_type] || typeIcons.other}`} style={{ fontSize: '1.4rem', color: tc }}></i>
                </div>
                <div>
                  <strong style={{ color: t.text }}>{mat.title}</strong><br />
                  <small style={{ color: t.textMuted, textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.5px' }}>{mat.file_type}{mat.extension && `  ·  .${mat.extension}`}</small>
                </div>
              </div>
              <button className="btn btn-sm" onClick={() => handleDownload(mat)} disabled={!mat.can_download} style={{
                background: 'transparent', border: `1.5px solid ${t.gold}`, color: t.gold,
                fontWeight: 600, borderRadius: '10px', padding: '8px 18px', cursor: mat.can_download ? 'pointer' : 'not-allowed', opacity: mat.can_download ? 1 : 0.5,
              }}>
                <i className={`bi ${mat.can_download ? 'bi-download' : 'bi-eye'} me-1`}></i>{mat.can_download ? 'Download' : 'Lihat'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
